import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { ROUTE_PATHS } from "@/lib/index";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Suppliers from "@/pages/Suppliers";
import SupplierDetail from "@/pages/SupplierDetail";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Contact from "@/pages/Contact";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import AdminSuppliers from "@/pages/admin/Suppliers";
import SupplierForm from "@/pages/admin/SupplierForm";
import AdminProducts from "@/pages/admin/Products";
import ProductForm from "@/pages/admin/ProductForm";
import AdminNews from "@/pages/admin/News";
import NewsForm from "@/pages/admin/NewsForm";
import Advertisements from "@/pages/admin/Advertisements";
import AdForm from "@/pages/admin/AdForm";
import Inquiries from "@/pages/admin/Inquiries";
import Subscribers from "@/pages/admin/Subscribers";
import TestPage from "@/pages/TestPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <MotionConfig reducedMotion="user">
        <Toaster />
        <Sonner />
        <HashRouter>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Layout><Home /></Layout>} />
            <Route path={ROUTE_PATHS.SUPPLIERS} element={<Layout><Suppliers /></Layout>} />
            <Route path={ROUTE_PATHS.SUPPLIER_DETAIL} element={<Layout><SupplierDetail /></Layout>} />
            <Route path={ROUTE_PATHS.PRODUCTS} element={<Layout><Products /></Layout>} />
            <Route path={ROUTE_PATHS.PRODUCT_DETAIL} element={<Layout><ProductDetail /></Layout>} />
            <Route path={ROUTE_PATHS.NEWS} element={<Layout><News /></Layout>} />
            <Route path={ROUTE_PATHS.NEWS_DETAIL} element={<Layout><NewsDetail /></Layout>} />
            <Route path={ROUTE_PATHS.CONTACT} element={<Layout><Contact /></Layout>} />
            <Route path="/test" element={<TestPage />} />
            <Route path={ROUTE_PATHS.ADMIN_LOGIN} element={<Login />} />
            <Route path={ROUTE_PATHS.ADMIN_DASHBOARD} element={<Dashboard />} />
            <Route path={ROUTE_PATHS.ADMIN_SUPPLIERS} element={<AdminSuppliers />} />
            <Route path="/manage/suppliers/new" element={<SupplierForm />} />
            <Route path="/manage/suppliers/:id/edit" element={<SupplierForm />} />
            <Route path={ROUTE_PATHS.ADMIN_PRODUCTS} element={<AdminProducts />} />
            <Route path="/manage/products/new" element={<ProductForm />} />
            <Route path="/manage/products/:id/edit" element={<ProductForm />} />
            <Route path={ROUTE_PATHS.ADMIN_NEWS} element={<AdminNews />} />
            <Route path="/manage/news/new" element={<NewsForm />} />
            <Route path="/manage/news/:id/edit" element={<NewsForm />} />
            <Route path={ROUTE_PATHS.ADMIN_ADS} element={<Advertisements />} />
            <Route path="/manage/advertisements/new" element={<AdForm />} />
            <Route path="/manage/advertisements/:id/edit" element={<AdForm />} />
            <Route path={ROUTE_PATHS.ADMIN_INQUIRIES} element={<Inquiries />} />
            <Route path={ROUTE_PATHS.ADMIN_SUBSCRIBERS} element={<Subscribers />} />
          </Routes>
        </HashRouter>
      </MotionConfig>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;